import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";

export async function getAllMeetingGroups(filter) {
   let url = "/global-configuration/ehs-module/all-meeting-groups?";

   if (filter) url += filter;

   try {
      const response = await RestMethod.GET(url);
      return response.data;
   } catch (error) {
      console.log("error detected while fetching data from api");
      return null;
   }
}

export async function createMeetingGroup(data) {
   try {
      const response = await RestMethod.POST("/global-configuration/ehs-module/create-meeting-group", data);
      return response.data;
   } catch (error) {
      console.log("error detected while fetching data from api");
      return null;
   }
}

export async function updateMeetingGroup(id, data) {
   try {
      const response = await RestMethod.PUT("/global-configuration/ehs-module/update-meeting-group/" + id, data);
      return response.data;
   } catch (error) {
      console.log("error detected while fetching data from api");
      return null;
   }
}

export async function deleteMeetingGroup(id) {
   try {
      const response = await RestMethod.DELETE("/global-configuration/ehs-module/delete-meeting-group/" + id);
      return response.data;
   } catch (error) {
      console.log("error detected while fetching data from api");
      return null;
   }
}
